import { noop } from 'angular';
var DrButtonComponentController = (function () {
    function DrButtonComponentController(cartChannel) {
        this.cartChannel = cartChannel;
        this.added = false;
    }
    DrButtonComponentController.prototype.$onInit = function () {
        var _this = this;
        this.cartChannel.onInit().then(function (initItems) {
            var allItemsIncluded = true;
            for (var _i = 0, initItems_1 = initItems; _i < initItems_1.length; _i++) {
                var items = initItems_1[_i];
                allItemsIncluded = true;
                allItemsIncluded = allItemsIncluded && items.length === _this.items.length;
                if (!allItemsIncluded) {
                    continue;
                }
                var _loop_1 = function (item) {
                    allItemsIncluded = allItemsIncluded && _this.items.some(function (x) { return x.sku === item.sku; });
                };
                for (var _a = 0, items_1 = items; _a < items_1.length; _a++) {
                    var item = items_1[_a];
                    _loop_1(item);
                }
                if (allItemsIncluded) {
                    break;
                }
            }
            _this.added = initItems.length > 0 && allItemsIncluded;
        }, noop);
        this.cartChannel.onAdd().then(noop, noop, function (items) {
            var allItemsIncluded = true;
            var _loop_2 = function (item) {
                allItemsIncluded = allItemsIncluded && _this.items.some(function (x) { return x.sku === item.sku; });
            };
            for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
                var item = items_2[_i];
                _loop_2(item);
            }
            if (!allItemsIncluded || _this.items.length !== items.length) {
                return;
            }
            _this.added = true;
        });
        this.cartChannel.onRemove().then(noop, noop, function (items) {
            var allItemsIncluded = true;
            var _loop_3 = function (item) {
                allItemsIncluded = allItemsIncluded && _this.items.some(function (x) { return x.sku === item.sku; });
            };
            for (var _i = 0, items_3 = items; _i < items_3.length; _i++) {
                var item = items_3[_i];
                _loop_3(item);
            }
            if (!allItemsIncluded) {
                return;
            }
            _this.added = false;
        });
    };
    DrButtonComponentController.prototype.add = function () {
        if (this.added) {
            return;
        }
        this.cartChannel.add(this.items);
    };
    DrButtonComponentController.$inject = ['cartChannel'];
    return DrButtonComponentController;
}());
export var DrButtonComponent = {
    bindings: {
        items: '<',
        onAdded: '&?',
        onRemoved: '&?',
    },
    controller: DrButtonComponentController,
    template: "\n    <span ng-if=\"$ctrl.items.length > 0\"\n          ng-click=\"$ctrl.add()\"\n          ng-class=\"{ added: $ctrl.added }\"\n          class=\"d-block\"\n          ng-transclude>\n    </span>\n  ",
    transclude: true,
};
